var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-product-new bg-2 p-6 rounded-16"},[_c('h6',{staticClass:"text-dark text-semibold fs-14 mb-4"},[_vm._v(" Escolha o tipo de produto que você deseja vender ")]),_c('big-buttons',{staticClass:"pt-3",attrs:{"options":[
      {
        id: 'online-course',
        name: 'Curso online',
        src: require("@/assets/images/new-product/curso-online.svg")
      },
      {
        id: 'signature',
        name: 'Assinatura',
        src: require("@/assets/images/new-product/assinatura.svg")
      },
      {
        id: 'event',
        name: 'Evento presencial',
        src: require("@/assets/images/new-product/ticket.svg")
      }
    ]},on:{"input":_vm.open}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }